import { defineTranslateKeys } from 'lib/tolgee'

export const trendTerritoryTitleTranslations = defineTranslateKeys({
  new1: {
    key: 'TrendTerritoryTitle-new-1',
    defaultValue: 'Hot to watch 🔥 Maior pico de relevância',
  },
  new2: {
    key: 'TrendTerritoryTitle-new-2',
    defaultValue: 'Em destaque pela grande quantidade de vídeos',
  },
  new3: {
    key: 'TrendTerritoryTitle-new-3',
    defaultValue: 'Crescendo agora, apesar do volume menor',
  },
  new4: ({ rank }: { rank: number }) => ({
    key: 'TrendTerritoryTitle-new-4',
    parameters: { rank },
    defaultValue: '#{rank} lugar no rank: fique de olho na evolução',
  }),
  new5: {
    key: 'TrendTerritoryTitle-new-5',
    defaultValue: 'Primeiro pico de relevância registrado',
  },
  new6: ({ createdAt }: { createdAt: string }) => ({
    key: 'TrendTerritoryTitle-new-6',
    parameters: { createdAt },
    defaultValue: 'Acompanhe: identificada em {createdAt}',
  }),
  trending1: {
    key: 'TrendTerritoryTitle-trending-1',
    defaultValue: 'Uma das maiores altas! Siga monitorando',
  },
  trending2: {
    key: 'TrendTerritoryTitle-trending-2',
    defaultValue: 'Alto volume: você provavelmente já viu 👀',
  },
  trending3: ({ postCount }: { postCount: number }) => ({
    key: 'TrendTerritoryTitle-trending-3',
    parameters: { postCount },
    defaultValue: 'Será que tem fit? Nichada com {postCount} vídeos',
  }),
  trending4: ({ activeDays }: { activeDays: number }) => ({
    key: 'TrendTerritoryTitle-trending-4',
    parameters: { activeDays },
    defaultValue: 'Monitore: ativa há {activeDays, plural, one {# dia} other {# dias}}',
  }),
  trending5: ({ activeDays }: { activeDays: number }) => ({
    key: 'TrendTerritoryTitle-trending-5',
    parameters: { activeDays },
    defaultValue: 'É recente: acontecendo há {activeDays, plural, one {# dia} other {# dias}}',
  }),
  trending6: ({ rank }: { rank: number }) => ({
    key: 'TrendTerritoryTitle-trending-6',
    parameters: { rank },
    defaultValue: 'Consta na #{rank} posição de relevância',
  }),
  empty1: {
    key: 'TrendTerritoryTitle-empty-1',
    defaultValue: 'Avalie: alto volume, sem novos picos',
  },
  empty3: {
    key: 'TrendTerritoryTitle-empty-3',
    defaultValue: 'Ainda em andamento, mas sem novos picos',
  },
})
